import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Button, Container, Row, Col, Form, Modal, Table, Stack, TabPane, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ccService from "../../services/cc.service";

const initialCC = {
    nombre: ""
}

const CC = () => {
    const [cc,setCC] = useState(initialCC);
    const [ccs, setCcs] = useState([]);

    useEffect(()=>{
        retreiveCCs();
    }, []);

    function retreiveCCs() {
        ccService.getAll()
        .then(cc=>{
            console.log(cc);
            setCcs(cc.data);
        })
        .catch(err=>{
            console.error(err);
        });
    }

    const handleChangeCC = (valor, nombre) => {
        setCC({...cc, [nombre]:valor});
    }

    const ingresarCC = () => {
        ccService.create(cc)
        .then(cn=>{
            console.log(cn);
            toast.info("Centro de costo ingresado correctamente!",{
                position:"top-center",
                autoClose: 2000
            });
            retreiveCCs();
        })
        .catch(err=>{
            console.error(err);
        });
    }

    function buttonFormat(cell, row) {
        return <Button variant="danger" onClick={() => eliminarCC(row.id)}><FontAwesomeIcon icon="fa-solid fa-trash-can" /></Button>;
    }

    const eliminarCC = (id) => {
        if (window.confirm("Esta seguro de eliminar el Centro de Costo?")) {
            ccService.eliminarCC(id)
            .then(data=>{
                toast.info(data.data.message,{
                    position: "top-center",
                    autoClose: 2000
                });
                retreiveCCs();
            })
            .catch(err=>{
                console.error(err);
            });
        }
    }

    return (
        <Container>
            <Row>
                <Col sm={4}>
                    <h4>Ingresar Centro Costo</h4>
                    <Form.Group>
                        <Form.Label>Nombre:</Form.Label>
                        <Form.Control type="text" onChange={(e)=>handleChangeCC(e.target.value, "nombre")} />
                    </Form.Group>
                    <div className="mt-3"></div>
                    <Button variant="primary" onClick={ingresarCC}>Agregar</Button>
                </Col>
                <Col>
                    <h4>Lista de Centros de Costo</h4>
                    <BootstrapTable data={ccs}>
                        <TableHeaderColumn dataField="id" isKey hidden>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField="nombre">Nombre</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={buttonFormat} width="15%" tdStyle={{ textAlign:"center", whiteSpace: 'normal', wordWrap: 'break-word' }}>Eliminar</TableHeaderColumn>
                    </BootstrapTable>
                </Col>
            </Row>
        </Container>
    )
}

export default CC;